import React from 'react';
import './normalPages.scss'

const SecurePayment = () => {
    return (
        <>
            <div className="normal_page">
                <h1>SECURE PAYMENT</h1>

                <div className="content">
                    <h2>Secure payment <br />Our secure payment</h2>

                    <p>With SSL </p><br />
                    <h2>Using Visa/Mastercard/Paypal</h2>

                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam odit iure deserunt voluptates. Nihil sapiente, velit dolore aliquid dolorem placeat accusamus culpa quidem ipsam veniam inventore fugiat ullam voluptate sed ut recusandae voluptatem quis. Amet ab deserunt eius quia maiores? Fugiat corrupti dolorum commodi voluptatum natus temporibus magni repudiandae suscipit.</p>
                </div>


            </div>
        </>
    );
};

export default SecurePayment;